import React from 'react';
import UserDataBase from './UserDataBase';

export default function UserData({ formik, preview, fileInputRef, isDefaultPhoto, handlePhotoChange, handleChangeImage, loading }) {
  return <UserDataBase formik={formik} preview={preview} fileInputRef={fileInputRef} isDefaultPhoto={isDefaultPhoto} handlePhotoChange={handlePhotoChange} handleChangeImage={handleChangeImage} loading={loading}/>;
};
